import { useEffect, useRef } from "react";
import { GOAL_OPTIONS } from "./marketing-data";

const goalClasses = (on) =>
    on
        ? "border-primary bg-primary/10 text-primary-darker"
        : "border-gray-200 bg-white text-gray-900 hover:border-primary/40";

const chipClasses = (on) =>
    on ? "border-[#082e54] bg-[#082e54] text-[#fff]" : "border-gray-200 bg-white text-gray-700 hover:border-gray-400";

export const useRevealPressed = (value) => {
    const rowRef = useRef(null);
    const mounted = useRef(false);

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        rowRef.current?.querySelector('[aria-pressed="true"]')?.scrollIntoView?.({ inline: "nearest", block: "nearest" });
    }, [value]);

    return rowRef;
};

const SWIPE_FADE =
    "relative max-lg:after:pointer-events-none max-lg:after:absolute max-lg:after:right-0 max-lg:after:top-0 max-lg:after:h-full max-lg:after:w-8 max-lg:after:bg-gradient-to-l max-lg:after:from-white max-lg:after:content-['']";

export const GoalPicker = ({ value, onChange, compact = false }) => {
    const rowRef = useRevealPressed(value);

    return (
        <div className="mb-[20px] rounded-2xl border-[1px] border-gray-200 bg-white pl-[16px] pr-[16px] pt-[16px] pb-[12px] shadow-[0_1px_2px_rgba(16,24,40,0.05)]">
            <p className="mb-2 text-xs font-bold tracking-[0.12em] text-gray-500">WHAT ARE YOU WORKING ON?</p>
            <div className={SWIPE_FADE}>
                <div
                    ref={rowRef}
                    role="group"
                    aria-label="What are you working on?"
                    className={`flex gap-2 pb-1 max-lg:overflow-x-auto max-lg:pr-8 lg:grid lg:grid-cols-3 ${compact ? "xl:grid-cols-3" : "xl:grid-cols-5"}`}
                >
                    {GOAL_OPTIONS.map((g) => (
                        <button
                            key={g.id}
                            type="button"
                            aria-pressed={g.id === value ? "true" : "false"}
                            onClick={() => onChange(g.id)}
                            className={`flex min-h-[44px] flex-none flex-col items-start justify-center whitespace-nowrap rounded-xl border pl-3 pr-3 pt-1.5 pb-1.5 text-left transition-colors lg:whitespace-normal ${goalClasses(g.id === value)}`}
                        >
                            <span className="text-sm font-bold">{g.label}</span>
                            <span className={`text-[12px] leading-tight text-gray-600 max-lg:sr-only ${compact ? "xl:sr-only" : ""}`}>{g.hint}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export const ProductFilter = ({ tabs, value, onChange }) => {
    const rowRef = useRevealPressed(value);

    return (
        <div>
            <p className="mb-2 text-xs font-bold tracking-[0.12em] text-gray-500">BROWSE BY PRODUCT</p>
            <div className="relative mb-2 max-md:after:pointer-events-none max-md:after:absolute max-md:after:right-0 max-md:after:top-0 max-md:after:h-full max-md:after:w-8 max-md:after:bg-gradient-to-l max-md:after:from-gray-50 max-md:after:content-['']">
                <div
                    ref={rowRef}
                    role="group"
                    aria-label="Browse by product"
                    className="flex gap-2 pb-1 max-md:overflow-x-auto max-md:pr-8 md:flex-wrap"
                >
                    {tabs.map((t) => (
                        <button
                            key={t.id}
                            type="button"
                            aria-pressed={t.id === value ? "true" : "false"}
                            onClick={() => onChange(t.id)}
                            className={`min-h-[44px] flex-none whitespace-nowrap rounded-full border-[1px] pl-4 pr-4 text-sm font-semibold transition-colors ${chipClasses(t.id === value)}`}
                        >
                            {t.label} <span className="font-normal opacity-70">({t.count})</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};
